import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import en_ja from '../../en-ja-map';

const DeliveryStatusUpdate = () => {
    const [id, setId] = useState(null);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        // Extract ID from URL path like /delivery-status/123
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/');
        const extractedId = pathParts[pathParts.length - 1]; // Get last part after final slash
        setId(extractedId);
    }, []);

    const updateDeliveryStatus = async () => {
        if (!id) return;
        setUpdating(true);
        setError('');

        try {
            const payload = {
                prescription_id: id,
                status: 'dispatched',
            };
            //const response = await api.post('/v1/update-prescription-status', payload);

            // Mock success for testing
            setTimeout(() => {
                setSuccess(true);
                setUpdating(false);
            }, 1500);
            return;
        } catch (error) {
            console.error('Error updating delivery status:', error);
            setError(en_ja['Failed to update delivery status. Please try again.'] || 'Failed to update delivery status. Please try again.');
            setUpdating(false);
        }
    };

    if (error && !success) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px'
            }}>
                <div style={{
                    padding: '32px',
                    textAlign: 'center',
                    borderRadius: '16px',
                    maxWidth: '400px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ fontSize: '48px', color: '#f44336', marginBottom: '16px' }}>⚠️</div>
                    <h3 style={{ color: '#f44336', marginBottom: '16px', fontWeight: '600' }}>
                        {en_ja['Error Updating Status'] || 'Error Updating Status'}
                    </h3>
                    <p style={{ color: '#666', marginBottom: '24px' }}>{error}</p>
                    <button
                        onClick={() => setError('')}
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
                    >
                        {en_ja['Try Again'] || 'Try Again'}
                    </button>
                </div>
            </div>
        );
    }

    if (success) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px'
            }}>
                <div style={{
                    padding: '32px',
                    textAlign: 'center',
                    borderRadius: '16px',
                    maxWidth: '400px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px',
                        boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)'
                    }}>
                        <span style={{ fontSize: '40px', color: 'white' }}>✓</span>
                    </div>
                    <h2 style={{ fontWeight: '600', marginBottom: '16px', color: '#2c2c2c' }}>
                        {en_ja['Status Updated Successfully!'] || 'Status Updated Successfully!'}
                    </h2>
                    <p style={{ color: '#666', marginBottom: '24px' }}>
                        {en_ja['The prescription has been marked as dispatched.'] || 'The prescription has been marked as dispatched.'}
                    </p>
                    <div style={{
                        padding: '16px',
                        backgroundColor: '#e8f5e8',
                        borderRadius: '12px',
                        border: '1px solid #4caf50'
                    }}>
                        <p style={{ fontWeight: '600', color: '#2e7d32', margin: '0 0 4px 0', fontSize: '14px' }}>
                            {en_ja['Current Status: Dispatched'] || 'Current Status: Dispatched'}
                        </p>
                        <p style={{ color: '#666', margin: '0', fontSize: '12px' }}>
                            {en_ja['Order is on the way to destination'] || 'Order is on the way to destination'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '16px' }}>
            <div style={{ maxWidth: '900px', margin: '0 auto', paddingTop: '24px' }}>
                <div style={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }}>
                    <div style={{
                        backgroundColor: '#dc3545',
                        color: 'white',
                        padding: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        <div style={{
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            color: 'white',
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <span style={{ fontSize: '24px' }}>🏥</span>
                        </div>
                        <div>
                            <h3 style={{ fontWeight: '600', margin: '0 0 4px 0' }}>
                                {en_ja['Prescription Order Ready'] || 'Prescription Order Ready'}
                            </h3>
                            <p style={{ opacity: '0.9', margin: '0', fontSize: '14px' }}>
                                {en_ja['Update the delivery status for this prescription'] || 'Update the delivery status for this prescription'}
                            </p>
                        </div>
                    </div>

                    <div style={{ padding: '48px', textAlign: 'center' }}>
                        <div style={{ marginBottom: '32px' }}>
                            <div style={{
                                width: '80px',
                                height: '80px',
                                margin: '0 auto 24px',
                                backgroundColor: '#f5f5f5',
                                color: '#666',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <span style={{ fontSize: '40px' }}>🚚</span>
                            </div>
                            <h2 style={{ fontWeight: '600', marginBottom: '16px', color: '#2c2c2c' }}>
                                {en_ja['Ready for Dispatch'] || 'Ready for Dispatch'}
                            </h2>
                            <p style={{ color: '#666', marginBottom: '8px', fontSize: '16px' }}>
                                {en_ja['A prescription order is ready to be dispatched.'] || 'A prescription order is ready to be dispatched.'}
                            </p>
                            <p style={{ color: '#999', fontSize: '14px' }}>
                                {en_ja['Click the button below to update the delivery status to "Dispatched"'] || 'Click the button below to update the delivery status to "Dispatched"'}
                            </p>
                        </div>

                        <button
                            onClick={updateDeliveryStatus}
                            disabled={updating}
                            style={{
                                backgroundColor: updating ? '#ccc' : '#dc3545',
                                color: 'white',
                                border: 'none',
                                padding: '16px 32px',
                                fontSize: '16px',
                                fontWeight: '600',
                                borderRadius: '12px',
                                minWidth: '200px',
                                cursor: updating ? 'not-allowed' : 'pointer',
                                transition: 'background-color 0.2s',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                            onMouseOver={(e) => {
                                if (!updating) e.target.style.backgroundColor = '#c82333';
                            }}
                            onMouseOut={(e) => {
                                if (!updating) e.target.style.backgroundColor = '#dc3545';
                            }}
                        >
                            {updating ? (
                                <>
                                    <div style={{
                                        width: '16px',
                                        height: '16px',
                                        border: '2px solid #ffffff40',
                                        borderTop: '2px solid #ffffff',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    {en_ja['Updating Status...'] || 'Updating Status...'}
                                </>
                            ) : (
                                <>
                                    🚚 {en_ja['Update Status'] || 'Update Status'}
                                </>
                            )}
                        </button>

                        {/* <p style={{ color: '#999', fontSize: '12px', marginTop: '24px' }}>
                            Order ID: {id || 'Loading...'}
                        </p> */}

                        {error && (
                            <div style={{
                                marginTop: '24px',
                                padding: '12px 16px',
                                backgroundColor: '#ffebee',
                                border: '1px solid #f44336',
                                borderRadius: '12px',
                                color: '#c62828'
                            }}>
                                {error}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
};

export default DeliveryStatusUpdate;